$(document).ready(function () {
	$('.content_pdf_1').show();
	$('.content_pdf_2').hide();
	$('.content_pdf_3').hide();
	$('.content_pdf_4').hide();
	$('.tabItem1').addClass('active');
	// tab1
	$('.tabList1 .tabItem1 a').click(function () {
		$('.content_pdf_1').show('fast');
		$('.content_pdf_2').hide('fast');
		$('.content_pdf_3').hide('fast');
		$('.content_pdf_4').hide('fast');
		$('.tabItem1').addClass('active');
		$('.tabItem2').removeClass('active');
		$('.tabItem3').removeClass('active');
		$('.tabItem4').removeClass('active');
		return false;
	});
	// tab2
	$('.tabList1 .tabItem2 a').click(function () {
		$('.content_pdf_1').hide('fast');
		$('.content_pdf_2').show('fast');
		$('.content_pdf_3').hide('fast');
		$('.content_pdf_4').hide('fast');
		$('.tabItem1').removeClass('active');
		$('.tabItem2').addClass('active');
		$('.tabItem3').removeClass('active');
		$('.tabItem4').removeClass('active');
		return false;
	});
	// tab3
	$('.tabList1 .tabItem3 a').click(function () {
		$('.content_pdf_1').hide('fast');
		$('.content_pdf_2').hide('fast');
		$('.content_pdf_3').show('fast');
		$('.content_pdf_4').hide('fast');
		$('.tabItem1').removeClass('active');
		$('.tabItem2').removeClass('active');
		$('.tabItem3').addClass('active');
		$('.tabItem4').removeClass('active');
		return false;
	});
	// tab4
	$('.tabList1 .tabItem4 a').click(function () {
		$('.content_pdf_1').hide('fast');
		$('.content_pdf_2').hide('fast');
		$('.content_pdf_3').hide('fast');
		$('.content_pdf_4').show('fast');
		$('.tabItem1').removeClass('active');
		$('.tabItem2').removeClass('active');
		$('.tabItem3').removeClass('active');
		$('.tabItem4').addClass('active');
		return false;
	});
});

$(document).ready(function () {
	$('.content_pdf2_1').show();
	$('.content_pdf2_2').hide();
	$('.content_pdf2_3').hide();
	$('.content_pdf2_4').hide();
	$('.tabItem3-1').addClass('active');
	// tab1
	$('.tabList3 .tabItem3-1 a').click(function () {
		$('.content_pdf2_1').show('fast');
		$('.content_pdf2_2').hide('fast');
		$('.content_pdf2_3').hide('fast');
		$('.content_pdf2_4').hide('fast');
		$('.tabItem3-1').addClass('active');
		$('.tabItem3-2').removeClass('active');
		$('.tabItem3-3').removeClass('active');
		$('.tabItem3-4').removeClass('active');
		return false;
	});
	// tab2
	$('.tabList3 .tabItem3-2 a').click(function () {
		$('.content_pdf2_1').hide('fast');
		$('.content_pdf2_2').show('fast');
		$('.content_pdf2_3').hide('fast');
		$('.content_pdf2_4').hide('fast');
		$('.tabItem3-1').removeClass('active');
		$('.tabItem3-2').addClass('active');
		$('.tabItem3-3').removeClass('active');
		$('.tabItem3-4').removeClass('active');
		return false;
	});
	// tab3
	$('.tabList3 .tabItem3-3 a').click(function () {
		$('.content_pdf2_1').hide('fast');
		$('.content_pdf2_2').hide('fast');
		$('.content_pdf2_3').show('fast');
		$('.content_pdf2_4').hide('fast');
		$('.tabItem3-1').removeClass('active');
		$('.tabItem3-2').removeClass('active');
		$('.tabItem3-3').addClass('active');
		$('.tabItem3-4').removeClass('active');
		return false;
	});
	// tab4
	$('.tabList3 .tabItem3-4 a').click(function () {
		$('.content_pdf2_1').hide('fast');
		$('.content_pdf2_2').hide('fast');
		$('.content_pdf2_3').hide('fast');
		$('.content_pdf2_4').show('fast');
		$('.tabItem3-1').removeClass('active');
		$('.tabItem3-2').removeClass('active');
		$('.tabItem3-3').removeClass('active');
		$('.tabItem3-4').addClass('active');
		return false;
	});
});

$(document).ready(function () {
	$('.tabArea .content_tools_1').show();
	$('.tabArea .content_tools_2').hide();
	$('.tabArea .content_tools_3').hide();
	$('.tabArea .content_tools_4').hide();

	$('.tabArea.Software .content_tools_1').hide();
	$('.tabArea.Software .content_tools_2').show();
	$('.tabArea.Software .content_tools_3').hide();
	$('.tabArea.Software .content_tools_4').hide();

	$('.tabList2 .tabItemS1').addClass('active');
	$('.tabList2.Software .tabItemS1').removeClass('active');
	$('.tabList2.Software .tabItemS2').addClass('active');
	// tab1
	$('.tabList2 .tabItemS1 a').click(function () {
		$('.tabArea .content_tools_1').show('fast');
		$('.tabArea .content_tools_2').hide('fast');
		$('.tabArea .content_tools_3').hide('fast');
		$('.tabArea .content_tools_4').hide('fast');
		$('.tabItemS1').addClass('active');
		$('.tabItemS2').removeClass('active');
		$('.tabItemS3').removeClass('active');
		$('.tabItemS4').removeClass('active');
		return false;
	});
	// tab2
	$('.tabList2 .tabItemS2 a').click(function () {
		$('.tabArea .content_tools_1').hide('fast');
		$('.tabArea .content_tools_2').show('fast');
		$('.tabArea .content_tools_3').hide('fast');
		$('.tabArea .content_tools_4').hide('fast');
		$('.tabItemS1').removeClass('active');
		$('.tabItemS2').addClass('active');
		$('.tabItemS3').removeClass('active');
		$('.tabItemS4').removeClass('active');
		return false;
	});
	// tab3
	$('.tabList2 .tabItemS3 a').click(function () {
		$('.tabArea .content_tools_1').hide('fast');
		$('.tabArea .content_tools_2').hide('fast');
		$('.tabArea .content_tools_3').show('fast');
		$('.tabArea .content_tools_4').hide('fast');
		$('.tabItemS1').removeClass('active');
		$('.tabItemS2').removeClass('active');
		$('.tabItemS3').addClass('active');
		$('.tabItemS4').removeClass('active');
		return false;
	});
	// tab4
	$('.tabList2 .tabItemS4 a').click(function () {
		$('.tabArea .content_tools_1').hide('fast');
		$('.tabArea .content_tools_2').hide('fast');
		$('.tabArea .content_tools_3').hide('fast');
		$('.tabArea .content_tools_4').show('fast');
		$('.tabItemS1').removeClass('active');
		$('.tabItemS2').removeClass('active');
		$('.tabItemS3').removeClass('active');
		$('.tabItemS4').addClass('active');
		return false;
	});
	// tools software listing anchorlink
	$('a.relatedProductsList').click(function () {
		$('.tabArea .content_tools_1').show('fast');
		$('.tabArea .content_tools_2').hide('fast');
		$('.tabArea .content_tools_3').hide('fast');
		$('.tabArea .content_tools_4').hide('fast');
		$('.tabItemS1').addClass('active');
		$('.tabItemS2').removeClass('active');
		$('.tabItemS3').removeClass('active');
		$('.tabItemS4').removeClass('active');
		return false;
	});
});
